/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ToolVariationGroup = {
  /**
   * The creation date of the tool variation group
   */
  createdAt: string;
  /**
   * The description of the tool variation group
   */
  description?: string | undefined;
  /**
   * The ID of the tool variation group
   */
  id: string;
  /**
   * The name of the tool variation group
   */
  name: string;
  /**
   * The last update date of the tool variation group
   */
  updatedAt: string;
};

/** @internal */
export const ToolVariationGroup$inboundSchema: z.ZodMiniType<
  ToolVariationGroup,
  unknown
> = z.pipe(
  z.object({
    created_at: z.string(),
    description: z.optional(z.string()),
    id: z.string(),
    name: z.string(),
    updated_at: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "updated_at": "updatedAt",
    });
  }),
);

export function toolVariationGroupFromJSON(
  jsonString: string,
): SafeParseResult<ToolVariationGroup, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolVariationGroup$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolVariationGroup' from JSON`,
  );
}
